/* Avis Maison Dolce - couche interactive au-dessus des donnees Judge.me
   v28 : la liste est reconstruite avec TOUS les avis lus en direct chez Judge.me (dolce-avis-live.js).
   Le rendu du serveur (métachamp, 5 avis) ne sert plus que de secours si Judge.me ne répond pas. */
(function () {
  "use strict";

  var root = document.querySelector("[data-dr]");
  if (!root) return;

  var IMPORTED = "review_collected_from_another_provider";

  function isImported(r) {
    return (r.transparency_badges || []).indexOf(IMPORTED) !== -1;
  }

  function frDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return "";
    return d.toLocaleDateString("fr-FR", { timeZone: "Europe/Paris", day: "2-digit", month: "2-digit", year: "numeric" });
  }

  /* Texte de l'avis : l'API ne donne que body_html. On n'en garde que le texte (paragraphes et retours
     à la ligne), réécrit et échappé : aucune balise venue de l'extérieur n'est injectée dans la page. */
  function bodyHtml(r, esc) {
    var src = r.body_html || "";
    if (!src && r.body) src = esc(r.body);
    var doc = new DOMParser().parseFromString(src, "text/html");
    [].slice.call(doc.body.querySelectorAll("br")).forEach(function (br) {
      br.parentNode.replaceChild(doc.createTextNode("\n"), br);
    });
    var ps = [].slice.call(doc.body.querySelectorAll("p"));
    var parts = ps.length ? ps.map(function (p) { return p.textContent; }) : [doc.body.textContent];
    return parts.filter(function (t) { return t.trim(); }).map(function (t) {
      return "<p>" + esc(t.trim()).replace(/\n/g, "<br>") + "</p>";
    }).join("");
  }

  /* ---------- rendu, identique à snippets/dolce-reviews.liquid ---------- */
  function cardHtml(r, J) {
    var esc = J.esc;
    var imported = isImported(r);
    var init = r.reviewer_initial || String(r.reviewer_name || "").charAt(0);
    var ts = Math.floor(new Date(r.created_at).getTime() / 1000) || 0;
    var body = bodyHtml(r, esc);
    var h = '<article class="dr-card" data-rating="' + esc(r.rating) + '" data-ts="' + ts + '">' +
      '<div class="dr-card__top"><span class="dr-av" aria-hidden="true">' + esc(String(init).toUpperCase()) + "</span>" +
      '<div class="dr-card__who"><b>' + esc(r.reviewer_name) + '</b><span class="dr-card__sub">' +
      '<time datetime="' + esc(r.created_at) + '">' + frDate(r.created_at) + "</time>";
    if (imported) {
      h += '<button class="dr-src" type="button" data-dr-howto aria-label="Avis du fournisseur — en savoir plus sur la collecte des avis">avis du fournisseur</button>';
    }
    h += "</span></div>";
    if (r.verified_buyer && !imported) {
      h += '<span class="dr-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg>Achat vérifié</span>';
    }
    h += "</div>" + '<div class="dr-card__rating">' + J.stars(r.rating) + "</div>";
    if (r.title) h += '<h4 class="dr-card__title">' + esc(r.title) + "</h4>";
    h += '<div class="dr-card__body">' + body + "</div>";

    var pics = (r.pictures_urls || []).map(function (u) {
      var big = (u && (u.huge || u.original)) || "";
      var small = (u && u.compact) || big;
      return /^https:\/\//.test(big) ? '<button class="dr-pic" type="button" data-dr-pic="' + esc(big) + '" aria-label="Agrandir la photo"><img src="' + esc(small) + '" alt="" loading="lazy" decoding="async"></button>' : "";
    }).join("");
    if (pics) h += '<div class="dr-pics">' + pics + "</div>";

    if (r.reply_content) {
      h += '<div class="dr-reply"><b>Réponse de ' + esc(r.shop_reply_name || "Maison Lumina") + "</b><p>" + esc(r.reply_content) + "</p></div>";
    }
    return h + "</article>";
  }

  function renderLive(d, J) {
    var total = parseInt(d.number_of_reviews, 10) || 0;
    var avg = d.average_rating;
    var revs = d.reviews || [];
    var histo = d.histogram || [];
    var head = root.querySelector(".section-head");
    var headHtml = head ? head.outerHTML : "";
    var title = root.getAttribute("data-product") || "";

    if (total === 0) {
      root.innerHTML = headHtml +
        '<div class="dr-none"><div class="dr-none__mark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3.6l2.6 5.3 5.9.9-4.2 4.1 1 5.8-5.3-2.8-5.3 2.8 1-5.8L3.5 9.8l5.9-.9L12 3.6z"/></svg></div>' +
        "<div><h3>Aucun avis pour l'instant</h3><p>Si vous avez commandé ce produit, votre retour aidera les prochains clients à choisir.</p>" +
        '<button class="btn btn-primary" type="button" data-dr-write data-product="' + J.esc(title) + '">Être le premier à donner son avis</button></div></div>';
      return;
    }

    var nImported = revs.filter(isImported).length;
    var h = headHtml +
      '<div class="dr-summary"><div class="dr-score">' +
      '<div class="dr-score__num" data-dr-count="' + J.esc(avg) + '">' + J.esc(avg) + "</div>" +
      '<div class="dr-score__stars">' + J.stars(avg, "l") + "</div>" +
      '<div class="dr-score__meta">' + total + " avis</div></div>" +
      '<div class="dr-histo" data-dr-histo>' +
      histo.map(function (row) {
        var empty = !row.frequency;
        return '<button class="dr-histo__row' + (empty ? " is-empty" : "") + '" type="button" data-dr-filter="' + row.rating + '"' + (empty ? " disabled" : "") +
          ' aria-label="' + row.frequency + " avis à " + row.rating + ' étoiles"><span class="dr-histo__label">' + row.rating + "<i>★</i></span>" +
          '<span class="dr-histo__track"><span class="dr-histo__fill" style="--dr-w:' + row.percentage + '%"></span></span>' +
          '<span class="dr-histo__count">' + row.frequency + "</span></button>";
      }).join("") + "</div></div>";

    if (nImported > 0) {
      h += '<p class="dr-origin" style="font-size:13.5px;opacity:.8;margin:10px 0 0;">Cette note comprend des avis laissés par des acheteurs sur la page du même article chez notre fournisseur (AliExpress), signalés « avis du fournisseur ».</p>';
    }

    var trust = root.querySelector(".dr-trust");
    var tpl = root.querySelector("template[data-dr-trust-tpl]");
    if (trust) h += trust.outerHTML;
    else if (tpl) h += tpl.innerHTML;

    h += '<div class="dr-toolbar"><div class="dr-chips" role="group" aria-label="Filtrer les avis par note">' +
      '<button class="dr-chip is-active" type="button" data-dr-filter="all">Tous <b>' + total + "</b></button>" +
      histo.filter(function (row) { return row.frequency > 0; }).map(function (row) {
        return '<button class="dr-chip" type="button" data-dr-filter="' + row.rating + '">' + row.rating + "★ <b>" + row.frequency + "</b></button>";
      }).join("") + "</div>" +
      '<label class="dr-sort"><span>Trier</span><select data-dr-sort aria-label="Trier les avis">' +
      '<option value="recent">Plus récents</option><option value="old">Plus anciens</option>' +
      '<option value="high">Mieux notés</option><option value="low">Moins bien notés</option></select></label></div>';

    h += '<div class="dr-list" data-dr-list>' + revs.map(function (r) { return cardHtml(r, J); }).join("") + "</div>" +
      '<p class="dr-empty" data-dr-empty hidden>Aucun avis ne correspond à ce filtre.</p>' +
      '<div class="dr-actions"><button class="btn dr-more" type="button" data-dr-more hidden>Voir plus d\'avis</button></div>';
    if (total > revs.length) h += '<p class="dr-foot">' + revs.length + " avis affichés sur " + total + ".</p>";

    root.innerHTML = h;
  }

  /* note en haut de la fiche, à côté du titre */
  /* (dolce-11.js la remplace ensuite par sa note .ml-rate, recalculée à l'événement « dr:live ») */
  function renderTop(d, J) {
    var total = parseInt(d.number_of_reviews, 10) || 0;
    [].slice.call(document.querySelectorAll(".pp-rating, .ml-rate")).forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    var row = document.querySelector(".pp-title-row");
    if (!total || !row) return;
    var top = document.createElement("a");
    top.className = "pp-rating";
    top.href = "#avis";
    top.innerHTML = J.stars(d.average_rating, "s") + "<b>" + J.esc(d.average_rating) + '</b><span class="pp-rating__count">(' + total + " avis)</span>";
    row.parentNode.insertBefore(top, row.nextSibling);
  }

  /* ---------- couche interactive (inchangée depuis la v27) ---------- */
  function init() {
    var PAGE = 6;
    var list = root.querySelector("[data-dr-list]");
    var cards = list ? [].slice.call(list.querySelectorAll(".dr-card")) : [];
    var chips = [].slice.call(root.querySelectorAll(".dr-chip"));
    var rows = [].slice.call(root.querySelectorAll(".dr-histo__row"));
    var sortSel = root.querySelector("[data-dr-sort]");
    var moreBtn = root.querySelector("[data-dr-more]");
    var emptyEl = root.querySelector("[data-dr-empty]");

    var filter = "all";
    var shown = PAGE;

    function num(el, attr) {
      return parseFloat(el.getAttribute(attr)) || 0;
    }

    function matching() {
      if (filter === "all") return cards;
      return cards.filter(function (c) {
        return String(num(c, "data-rating")) === String(filter);
      });
    }

    function applySort() {
      if (!sortSel || !list) return;
      var mode = sortSel.value;
      var sorted = cards.slice().sort(function (a, b) {
        if (mode === "recent") return num(b, "data-ts") - num(a, "data-ts");
        if (mode === "old") return num(a, "data-ts") - num(b, "data-ts");
        if (mode === "high") return num(b, "data-rating") - num(a, "data-rating") || num(b, "data-ts") - num(a, "data-ts");
        return num(a, "data-rating") - num(b, "data-rating") || num(b, "data-ts") - num(a, "data-ts");
      });
      sorted.forEach(function (c) {
        list.appendChild(c);
      });
      cards = sorted;
    }

    function render() {
      var visible = matching();
      cards.forEach(function (c) {
        c.hidden = true;
      });
      visible.slice(0, shown).forEach(function (c, i) {
        c.hidden = false;
        c.style.animationDelay = i < PAGE ? i * 45 + "ms" : "0ms";
      });
      if (emptyEl) emptyEl.hidden = visible.length !== 0;
      if (moreBtn) {
        var rest = visible.length - shown;
        moreBtn.hidden = rest <= 0;
        moreBtn.textContent = rest > 0 ? "Voir " + rest + " avis de plus" : "Voir plus d'avis";
      }
    }

    function setFilter(val) {
      filter = String(val);
      shown = PAGE;
      chips.forEach(function (c) {
        c.classList.toggle("is-active", c.getAttribute("data-dr-filter") === filter);
      });
      rows.forEach(function (r) {
        r.classList.toggle("is-active", r.getAttribute("data-dr-filter") === filter);
      });
      render();
    }

    chips.concat(rows).forEach(function (el) {
      el.addEventListener("click", function () {
        if (el.disabled) return;
        var val = el.getAttribute("data-dr-filter");
        setFilter(val === filter && val !== "all" ? "all" : val);
      });
    });

    if (sortSel) {
      sortSel.addEventListener("change", function () {
        shown = PAGE;
        applySort();
        render();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener("click", function () {
        shown += PAGE;
        render();
      });
    }

    /* panneau "comment nous collectons les avis" */
    var trustBtn = root.querySelector(".dr-trust__btn");
    var trustPanel = root.querySelector(".dr-trust__panel");

    function openTrust(scroll) {
      if (!trustPanel || !trustBtn) return;
      trustPanel.hidden = false;
      trustBtn.setAttribute("aria-expanded", "true");
      if (scroll && trustPanel.scrollIntoView) {
        trustPanel.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    [].slice.call(root.querySelectorAll("[data-dr-howto]")).forEach(function (el) {
      el.addEventListener("click", function () {
        if (!trustPanel || !trustBtn) return;
        if (el === trustBtn) {
          var open = trustPanel.hidden;
          trustPanel.hidden = !open;
          trustBtn.setAttribute("aria-expanded", open ? "true" : "false");
        } else {
          openTrust(true);
        }
      });
    });

    /* compteur de la note moyenne */
    function countUp(el) {
      var target = parseFloat(el.getAttribute("data-dr-count")) || 0;
      if (!target) return;
      var start = null;
      var dur = 900;
      function step(ts) {
        if (start === null) start = ts;
        var k = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - k, 3);
        el.textContent = (target * eased).toFixed(2);
        if (k < 1) requestAnimationFrame(step);
        else el.textContent = el.getAttribute("data-dr-count");
      }
      requestAnimationFrame(step);
    }

    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function reveal() {
      if (root.classList.contains("is-in")) return;
      root.classList.add("is-in");
      var scoreEl = root.querySelector("[data-dr-count]");
      if (scoreEl && !reduce) countUp(scoreEl);
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              reveal();
              io.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      io.observe(root);
      setTimeout(reveal, 2500);
    } else {
      reveal();
    }

    /* bouton ecrire un avis */
    [].slice.call(document.querySelectorAll("[data-dr-write]")).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var jdgm = document.querySelector(".jdgm-write-rev-link");
        if (jdgm) {
          jdgm.click();
          return;
        }
        window.location.href = "/pages/contact?sujet=" + encodeURIComponent("Avis sur " + (btn.getAttribute("data-product") || ""));
      });
    });

    applySort();
    render();
  }

  /* lightbox photos (délégation : fonctionne aussi après le rendu en direct) */
  var lb = document.getElementById("drLightbox");
  var lbImg = document.getElementById("drLightboxImg");
  if (lb && lbImg) {
    var closeLb = function () {
      lb.hidden = true;
      lbImg.removeAttribute("src");
      document.body.style.overflow = "";
    };
    root.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest("[data-dr-pic]") : null;
      if (!btn) return;
      lbImg.src = btn.getAttribute("data-dr-pic");
      lb.hidden = false;
      document.body.style.overflow = "hidden";
    });
    lb.addEventListener("click", function (e) {
      if (e.target === lb || (e.target.closest && e.target.closest(".dr-lightbox__close"))) closeLb();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !lb.hidden) closeLb();
    });
  }

  var J = window.mlJdgm;
  var pid = root.getAttribute("data-dr-pid");
  if (!J || !pid) return init();

  root.setAttribute("aria-busy", "true");
  J.fetchAll(pid)
    .then(function (d) {
      renderLive(d, J);
      renderTop(d, J);
      root.setAttribute("data-dr-live", String(d.reviews.length));
      document.dispatchEvent(new CustomEvent("dr:live"));
    })
    .catch(function () {
      root.setAttribute("data-dr-live", "erreur");
    })
    .then(function () {
      root.removeAttribute("aria-busy");
      init();
    });
})();
